import Vue from "vue";
import Vuex from "vuex";
import db from "./api/db";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: "ru",
    packageVersion: process.env.PACKAGE_VERSION || "0",
    token: "",
    ui: {
      title: "Панель администрирования",
      user: {
        display_name: "Аноним",
        display_image: "default.jpg",
        role: "Гость"
      },
      main_menu: {}
    },

    dialog: {
      result: null,
      message: null
    }
  },
  getters: {
    getLocale(state) {
      return state.lang;
    },
    getTitle(state) {
      return state.ui.title;
    },
    appVersion: state => {
      return state.packageVersion;
    }
  },
  mutations: {
    setLocale(state, payload) {
      state.lang = payload;
    },
    setTitle(state, payload) {
      state.ui.title = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    },
    setUser(state, payload) {
      console.log("store.setUser", payload);
      Vue.set(state.ui, "user", payload);
      state.user = payload;
    },
    updateUI(state, payload) {
      state.ui.title = payload.title || state.ui.title;
      state.ui.main_menu = payload.main_menu;
      state.ui.languages = payload.languages;
    }
  },
  actions: {
    async loadLocale(context) {
      const lang = await db.getLocale();
      if (lang) context.commit("setLocale", lang);
      else context.commit("setLocale", "ru");
    },
    async loadToken(context) {
      const token = await db.getToken();
      console.log("TOKEN", token);
      context.commit("setToken", token);
    },
    async loadUser(context) {
      const user = await db.getUser();
      context.commit("setUser", user);
    }
  }
});
